// ABOUTME: Formats the time between two ISO timestamps as a compact duration ("1h 2m 3s").
// ABOUTME: A missing end means "until now", so a running job's duration keeps growing.

/** Compact duration of a millisecond span: "25 ms", "2.4 s", "2m 5s", "1h 0m 12s", "2d 3h". */
export const formatDurationMs = (ms: number): string => {
    if (!Number.isFinite(ms) || ms < 0) return '';
    // Short jobs are common: below a minute the exact span says more than a rounded "0s".
    if (ms < 1000) return `${Math.round(ms)} ms`;
    if (ms < 60_000) return `${(Math.floor(ms / 100) / 10).toFixed(1)} s`;
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
    return `${minutes}m ${seconds}s`;
};

/** Duration between two ISO timestamps; empty when the start is unknown. */
export const formatDuration = (
    startedAt: string | null | undefined,
    endedAt: string | null | undefined,
    now: number = Date.now(),
): string => {
    if (!startedAt) return '';
    const start = new Date(startedAt).getTime();
    const end = endedAt ? new Date(endedAt).getTime() : now;
    return formatDurationMs(end - start);
};
